import {Component} from '@angular/core';
import {DynamicDialogRef} from "primeng/dynamicdialog";

@Component({
    selector: 'app-ms-provider-select',
    templateUrl: './ms-provider-select.component.html',
    styleUrl: './ms-provider-select.component.scss',
    standalone: false
})
export class MsProviderSelectComponent {

  constructor(public ref: DynamicDialogRef) { }

  select(provider: 'microsoft' | 'google'): void {
    this.ref.close(provider);
  }
}
